import { Outlet } from 'react-router-dom';
import type { CSSProperties } from 'react';
import Footer from '@/components/organisms/Footer';
import { SidebarProvider } from '../atoms/Sidebar';
import { AppSidebar } from '../organisms/AppSidebar';
import { AppNavbar } from '../organisms/AppNavbar';
import { SidebarInset } from '../atoms/Sidebar';
import ScrollToTop from '@/routes/ScrollToTop';
import { MembershipContentLock } from '@/components/membership/MembershipContentLock';
import { useMembershipPreviewAccess } from '@/hooks/useMembershipPreviewAccess';

type RootlayoutProps = {
  isViewFooter?: boolean;
  bgColor?: string;
};

type SidebarStyle = CSSProperties & {
  '--sidebar-top': string;
  '--sidebar-width': string;
};

const sidebarStyle: SidebarStyle = {
  '--sidebar-top': '0px',
  '--sidebar-width': '220px',
};

const PCRootLayout = ({ bgColor = 'bg-gr-50', isViewFooter = false }: RootlayoutProps) => {
  const shouldShowMembershipPreview = useMembershipPreviewAccess();

  return (
    <div className="flex h-[100dvh] flex-col">
      <ScrollToTop />

      <div className="flex flex-1">
        <SidebarProvider
          style={sidebarStyle}
          className="h-full bg-white transition-all duration-300"
          defaultOpen={true}
        >
          {/* height 계산된 사이드바 */}
          <div className="">
            <AppSidebar />
          </div>
          <SidebarInset>
            {/* 메인 컨텐츠 */}
            <div className={`z-[5] flex h-full w-full flex-col ${bgColor}`}>
              <AppNavbar />
              <div className="flex h-full w-full">
                <MembershipContentLock isLocked={shouldShowMembershipPreview}>
                  <Outlet />
                </MembershipContentLock>
              </div>
              {isViewFooter && <Footer />}
            </div>
          </SidebarInset>
        </SidebarProvider>
      </div>
    </div>
  );
};

export default PCRootLayout;
